<template>
    <div v-if="completeProfileSteps.length != totalProfileSteps.length" @click="goToNextStep()" class="text-sm md:text-base flex flex-row items-center space-x-2 w-full pt-1.5 cursor-pointer hover:underline">
        <div class="flex items-center justify-start space-x-1 whitespace-nowrap">
            <div>Complete your profile:</div>
            <div>{{ percentComplete }}%</div>
        </div>
        <div  class="flex items-center space-x-1 w-full">
            <div v-for="(profileSetupStep, index) in completeProfileSteps" :key="index" class="h-4 w-full rounded-xl border bg-indigo-200 border-indigo-300"></div>
            <div 
                v-for="(profileSetupStep, index) in incompleteProfileSteps" 
                :key="index" 
                class="h-4 w-full rounded-xl border bg-gray-200 border-gray-300"
                :class="getSetupStepClass(index)"
                ></div>
        </div>
    </div>
    <div v-else></div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { pageVisitLogger} from '@/composables/PageVisitLogging';

const props = defineProps(['profileSetupSteps', 'route'])

const { navigateToPage } = pageVisitLogger()

const completeProfileSteps = computed(() => {
    return props.profileSetupSteps.filter((profileSetupStep) => { return profileSetupStep.status == true})
})

const incompleteProfileSteps = computed(() => {
      return props.profileSetupSteps.filter((profileSetupStep) => { return profileSetupStep.status == false})
})

const percentComplete = computed(() => {
    return Math.floor(completeProfileSteps.value.length / totalProfileSteps.value.length * 100)
})

const totalProfileSteps = computed(() => {
    return props.profileSetupSteps
})

function getSetupStepClass(index) {
    if(index==0) {
        return 'animate-pulse border-indigo-300 bg-indigo-200'
    }
}

function goToNextStep() {
    const nextStep = incompleteProfileSteps.value[0]
    navigateToPage(nextStep.path, nextStep.name)
}
</script>